import { feetToMillimeters } from "@tedivo/tedivo-pure-helpers";

export const EIGHTANDHALF_FEET_IN_MM = feetToMillimeters(8.5);
export const EIGHT_FEET_IN_MM = feetToMillimeters(8);

export const BOTTOM_BASE_IN_MM = 1000;
export const MID_HEIGHT_SEPARATION_TO_DECK = 500;
